import React from "react"
import { FaTicketAlt } from "react-icons/fa"
import Title from "./title"
import PriceTable from "./priceTable"
import DiamondCard from "./diamondCard"

// Styles
import styles from "../styles/components/membership.module.scss"

// Images
import platinumIcon from "../images/lifetime-fitness-platinum-membership-icon.svg"
import goldIcon from "../images/lifetime-fitness-gold-membership-icon.svg"
import silverIcon from "../images/lifetime-fitness-silver-membership-icon.svg"
import bronzeIcon from "../images/lifetime-fitness-bronze-membership-icon.svg"
import diamondIcon from "../images/lifetime-fitness-diamond-membership-icon.svg"

import LFPricing1 from "../images/promo_1.png"
import LFPricing2 from "../images/promo_2.png"

const priceDetails = [
  {
    icon: diamondIcon,
    type: "Diamond",
    time: "Exclusive Membership",
    features: ["Full Time Personal Trainer", "Workout Plan", "Diet Plan"],
    prices: [
      {
        desc: "Gym Membership (1 Month)",
        price: "Rs. 45,000",
      },
    ],
    conditions: ["(Conditions Apply*)"],
  },
  {
    icon: platinumIcon,
    type: "Platinum",
    time: "4:00am to 12:00 Midnight",
    prices: [
      {
        desc: "Gents - Annual",
        price: "Rs. 65,000",
      },
      {
        desc: "Ladies - Annual",
        price: "Rs. 60,000",
      },
      {
        desc: "Couple - Annual",
        price: "Rs. 90,000",
      },
    ],
  },
  {
    icon: goldIcon,
    type: "Gold",
    time: "4:00am to 4:30pm",
    prices: [
      {
        desc: "Gents - Annual",
        price: "Rs. 55,000",
      },
      {
        desc: "Ladies - Annual",
        price: "Rs. 55,000",
      },
      {
        desc: "Couple - Annual",
        price: "Rs. 70,000",
      },
    ],
  },
  {
    icon: silverIcon,
    type: "Silver",
    time: "4:00am to 12:00 Midnight",
    prices: [
      {
        desc: "Individual - 6 Months",
        price: "Rs. 45,000",
      },
      {
        desc: "Individual - 3 Months",
        price: "Rs. 35,000",
      },
    ],
  },
]

const Membership = () => {
  return (
    <div className={styles.main} id="pricing">
      <p className={styles.eyebrow}>Choose what fits you</p>
      <Title text="Member Pricing" />
      <p className={styles.tagline}>
        Premium training. Real results. A stronger you.
      </p>
      <div className={styles.grid}>
        <DiamondCard info={priceDetails[0]} />
        <PriceTable info={priceDetails[1]} />
        <PriceTable info={priceDetails[2]} />
        <PriceTable info={priceDetails[3]} />
      </div>
      <div className={styles.info}>
        <p className={styles.dayPass}><FaTicketAlt aria-hidden="true" /><span>Day Pass: <strong>Rs. 2,000</strong></span></p>
      </div>
      <div className={styles.infoMobile}>
        <a href="tel:+94777775576" className={styles.btn}>Call Now</a>
      </div>
    </div>
  )
}

export default Membership
